import { useTranslation } from 'react-i18next';
import { ModalTemplate } from '../ModalTemplate';
import { BoxOpeningHours } from '../styles';
import { getLinkSupport } from '~/helpers/support';
import { ScheduleBadge } from '~/pages/RemoteControl/MachineProfile/components/ScheduleBadge';

interface OpeningHours {
  isOpen: boolean;
  onClose: () => void;
  interval?: {startTime: string; endTime: string}
}

export const ModalMachineOpeningHours: React.FC<OpeningHours> = ({
  isOpen,
  onClose,
  interval,
}) => {
  const { t } = useTranslation();
  const now = new Date().getHours();
  const isOutsideHours = now < 8 || now > 17;

  function onClickActionButton(): void {
    const linkSupport = getLinkSupport();

    window.open(linkSupport, '_blank');
  }

  return (
    <ModalTemplate
      isOpen={isOpen}
      onClose={onClose}
      text={t('maquinaForaDoHorarioInfo')}
      title={t('maquinaForaDoHorario')}
      iconTitle={<></>}
      button1={{
        label: isOutsideHours ? t('suporteDisponivel8as18') : t('conversarSuporte'),
        options: {
          disabled: isOutsideHours,
        },
      }}
      button1Action={onClickActionButton}
      imageText={(
        <BoxOpeningHours>
          {t('horarioDeFuncionamentoMaquina')}
          <ScheduleBadge
            beginTime={interval?.startTime}
            endTime={interval?.endTime}
          />
        </BoxOpeningHours>
      )}
      hasCloseButton
      fontSizeText={12}
      dataTestId="machine-opening-hours"
    />
  );
};
